import axios from "axios";
import { beforeRequestHandler } from "./HandleGlobalInterceptors";
import config from "@/config";
var instanceV1 = axios.create({ baseURL: config.gaGatewayUrl });
var APIInstanceGaGateway = /** @class */ (function () {
    function APIInstanceGaGateway(instance) {
        var _this = this;
        // NOTE: deliberately no response interceptor. The shared `requestErrorHandler`
        // clears the auth cache and redirects to /auth/login on any 401, which would
        // eject a user who has just created an account whenever this separate
        // service is down, misconfigured or not yet deployed. Attribution is
        // fire-and-forget, so rejecting locally loses nothing.
        this.registerGlobalRequestInterceptors = function () {
            _this.instance.interceptors.request.use(beforeRequestHandler);
        };
        this.instance = instance;
        this.registerGlobalRequestInterceptors();
    }
    Object.defineProperty(APIInstanceGaGateway.prototype, "buffedInstances", {
        get: function () {
            return this.instance;
        },
        enumerable: false,
        configurable: true
    });
    APIInstanceGaGateway.prototype.setAuthorizationToken = function (token) {
        try {
            this.instance.defaults.headers["Authorization"] = "Bearer ".concat(token);
        }
        catch (error) {
            console.error("Failed to set authorization token: ".concat(error));
        }
    };
    return APIInstanceGaGateway;
}());
export var MPInstanceGaGateway = new APIInstanceGaGateway(instanceV1);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVxdWVzdEF4aW9zR2FHYXRld2F5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUmVxdWVzdEF4aW9zR2FHYXRld2F5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBd0IsTUFBTSxPQUFPLENBQUM7QUFDN0MsT0FBTyxFQUFFLG9CQUFvQixFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFDbEUsT0FBTyxNQUFNLE1BQU0sVUFBVSxDQUFDO0FBRTlCLElBQU0sVUFBVSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsRUFBRSxPQUFPLEVBQUUsTUFBTSxDQUFDLFlBQVksRUFBRSxDQUFDLENBQUM7QUFFbEU7SUFHRSw4QkFBWSxRQUF1QjtRQUFuQyxpQkFHQztRQWNELCtFQUErRTtRQUMvRSw2RUFBNkU7UUFDN0Usc0VBQXNFO1FBQ3RFLHFFQUFxRTtRQUNyRSx1REFBdUQ7UUFDL0Msc0NBQWlDLEdBQUc7WUFDMUMsS0FBSSxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDO1FBQy9ELENBQUMsQ0FBQztRQXZCQSxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztRQUN6QixJQUFJLENBQUMsaUNBQWlDLEVBQUUsQ0FBQztJQUMzQyxDQUFDO0lBRUQsc0JBQVcsaURBQWU7YUFBMUI7WUFDRSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7UUFDdkIsQ0FBQzs7O09BQUE7SUFFTSxvREFBcUIsR0FBNUIsVUFBNkIsS0FBYTtRQUN4QyxJQUFJO1lBQ0YsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxHQUFHLGlCQUFVLEtBQUssQ0FBRSxDQUFDO1NBQ3JFO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDZCxPQUFPLENBQUMsS0FBSyxDQUFDLDZDQUFzQyxLQUFLLENBQUUsQ0FBQyxDQUFDO1NBQzlEO0lBQ0gsQ0FBQztJQVVILDJCQUFDO0FBQUQsQ0FBQyxBQTVCRCxJQTRCQztBQUVELE1BQU0sQ0FBQyxJQUFNLG1CQUFtQixHQUFHLElBQUksb0JBQW9CLENBQUMsVUFBVSxDQUFDLENBQUMifQ==